/**
 * Search Drawer JS
 * Handles toggle, keyboard navigation, focus management,
 * and Splide slider initialization for Search Drawer overlay.
 */

var _searchPreviouslyFocused = null;

function setSearchTriggersExpanded(isOpen) {
  var triggers = document.querySelectorAll(
    '.js-search-toggle[aria-expanded], .header-cell--search[aria-expanded]'
  );
  Array.prototype.forEach.call(triggers, function (trigger) {
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
}

function hydrateSearchDrawerFeatured() {
  var template = document.querySelector('template.js-search-drawer-featured');
  if (template) template.replaceWith(template.content);
}

function hydrateSearchDrawerOnIntent(e) {
  var target = e.target;
  if (target && target.closest && target.closest('.js-search-toggle, .header-cell--search')) {
    hydrateSearchDrawerFeatured();
  }
}

document.addEventListener('pointerover', hydrateSearchDrawerOnIntent, { passive: true });
document.addEventListener('touchstart', hydrateSearchDrawerOnIntent, { passive: true });
document.addEventListener('focusin', hydrateSearchDrawerOnIntent);

function openSearchDrawer() {
  var drawer = document.querySelector('.search-sidebar');
  if (!drawer) return;

  hydrateSearchDrawerFeatured();

  _searchPreviouslyFocused = document.activeElement;

  if (window.closeOtherDrawers) window.closeOtherDrawers(['open-search-drawer']);
  if (window.smUnparkPanel) window.smUnparkPanel(drawer);
  document.body.classList.add('open-search-drawer');

  drawer.setAttribute('aria-hidden', 'false');
  drawer.removeAttribute('inert');
  setSearchTriggersExpanded(true);

  var input = drawer.querySelector('.search-drawer__input');
  if (input) {
    setTimeout(function() { input.focus(); }, 100);
  }

  if (typeof window.initProductCardSplides === 'function') {
    window.initProductCardSplides(drawer);
  }
}

function closeSearchDrawer(restoreFocus) {
  var drawer = document.querySelector('.search-sidebar');
  if (!drawer) return;

  /* Set before the already-closed guard so the drawer can never be left
     interactive-but-invisible (see the comment in sections/search-drawer.liquid). */
  drawer.setAttribute('inert', '');

  if (!document.body.classList.contains('open-search-drawer') &&
      !document.body.classList.contains('open-search')) return;

  document.body.classList.remove('open-search-drawer', 'open-search');
  if (window.smParkPanel) window.smParkPanel(drawer);
  drawer.setAttribute('aria-hidden', 'true');
  setSearchTriggersExpanded(false);

  if (restoreFocus !== false && _searchPreviouslyFocused && _searchPreviouslyFocused.focus) {
    _searchPreviouslyFocused.focus();
  }
}

if (window.registerDrawerCloser) {
  window.registerDrawerCloser('open-search-drawer', function () { closeSearchDrawer(false); });
}

function toggleSearchDrawer() {
  if (document.body.classList.contains('open-search-drawer') || document.body.classList.contains('open-search')) {
    closeSearchDrawer();
  } else {
    openSearchDrawer();
  }
}

document.addEventListener('click', function (e) {
  var searchToggle = e.target.closest('.js-search-toggle') || e.target.closest('.header-cell--search');
  if (searchToggle) {
    e.preventDefault();
    toggleSearchDrawer();
    return;
  }

  var tagBtn = e.target.closest('.js-search-tag') || e.target.closest('.search-drawer__tag');
  if (tagBtn) {
    e.preventDefault();
    var val = tagBtn.dataset.value || tagBtn.textContent.trim();
    var input = document.querySelector('.search-drawer__input');
    if (input && val) {
      input.value = val;
      input.classList.add('has-value');
      input.focus();
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    return;
  }

  if (document.body.classList.contains('open-search-drawer') || document.body.classList.contains('open-search')) {
    var drawer = document.querySelector('.search-sidebar');
    if (drawer && !drawer.contains(e.target) && !e.target.closest('.js-search-toggle') && !e.target.closest('.header-cell--search')) {
      closeSearchDrawer();
    }
  }
});

document.addEventListener('keydown', function (e) {
  var isOpen = document.body.classList.contains('open-search-drawer') ||
               document.body.classList.contains('open-search');
  if (!isOpen) return;

  if (e.key === 'Escape') {
    closeSearchDrawer();
    return;
  }

  if (e.key !== 'Tab') return;

  var drawer = document.querySelector('.search-sidebar');
  if (!drawer) return;

  var focusable = Array.prototype.filter.call(
    drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
    function (el) { return el.offsetParent !== null; }
  );
  if (!focusable.length) return;

  var first = focusable[0];
  var last = focusable[focusable.length - 1];

  if (e.shiftKey) {
    if (document.activeElement === first || document.activeElement === drawer) {
      e.preventDefault();
      last.focus();
    }
  } else if (document.activeElement === last) {
    e.preventDefault();
    first.focus();
  }
});

var _searchDebounceTimer = null;
var SEARCH_DRAWER_RESULT_LIMIT = 6;

/** Hide + empty the persistent "View all results" footer (outside the scroll area). */
function clearSearchDrawerViewAll() {
  var viewAllWrap = document.querySelector('.search-drawer__view-all-wrap');
  if (!viewAllWrap) return;
  viewAllWrap.hidden = true;
  viewAllWrap.innerHTML = '';
}

function performSearchDrawerPredictive(searchTerm) {
  var drawer = document.querySelector('.search-drawer');
  var sidebar = document.querySelector('.search-sidebar');
  var resultsContainer = document.querySelector('.search-drawer__results-container');
  var defaultView = document.querySelector('.search-drawer__default-view');
  if (!resultsContainer || !defaultView) return;

  var query = searchTerm.trim();
  if (query.length === 0) {
    resultsContainer.style.display = 'none';
    resultsContainer.innerHTML = '';
    defaultView.style.display = 'block';
    if (drawer) drawer.classList.remove('has-search-results');
    if (sidebar) sidebar.classList.remove('has-search-results');
    clearSearchDrawerViewAll();
    return;
  }

  fetch('/search/suggest?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=10&section_id=predictive-search')
    .then(function (response) {
      if (!response.ok) throw new Error(response.status);
      return response.text();
    })
    .then(function (text) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(text, 'text/html');
      var resultsMarkup = doc.querySelector('#predictive-search-results');

      if (resultsMarkup) {
        var count = parseInt(resultsMarkup.dataset.count, 10) || 0;
        var isNoResults = resultsMarkup.classList.contains('is-no-results') || count === 0;

        resultsContainer.innerHTML = resultsMarkup.outerHTML;
        resultsContainer.style.display = 'block';

        Array.prototype.slice
          .call(resultsContainer.querySelectorAll('.search-drawer__results-item'), SEARCH_DRAWER_RESULT_LIMIT)
          .forEach(function (item) { item.remove(); });

        if (isNoResults) {
          defaultView.style.display = 'block';
          if (drawer) drawer.classList.remove('has-search-results');
          if (sidebar) sidebar.classList.remove('has-search-results');
          clearSearchDrawerViewAll();
        } else {
          defaultView.style.display = 'none';
          if (drawer) drawer.classList.add('has-search-results');
          if (sidebar) sidebar.classList.add('has-search-results');

          /* Move the "View all results" form out of the scrollable results
             markup into the persistent footer (see sections/search-drawer.liquid),
             then show that footer only now that there are results to view. */
          var viewAllForm = resultsContainer.querySelector('.js-view-all-form');
          var viewAllWrap = document.querySelector('.search-drawer__view-all-wrap');
          if (viewAllForm && viewAllWrap) {
            viewAllWrap.innerHTML = '';
            viewAllWrap.appendChild(viewAllForm);
            viewAllWrap.hidden = false;
          } else {
            clearSearchDrawerViewAll();
          }
        }

        if (typeof quickAddButton === 'function') {
          quickAddButton();
        }
        if (typeof window.initProductCardSplides === 'function') {
          window.initProductCardSplides(resultsContainer);
        }
      }
    })
    .catch(function (err) {
      console.error('Error fetching predictive search:', err);
      clearSearchDrawerViewAll();
    });
}

document.addEventListener('input', function (e) {
  if (e.target.matches('.search-drawer__input')) {
    var query = e.target.value;
    if (query.trim().length > 0) {
      e.target.classList.add('has-value');
    } else {
      e.target.classList.remove('has-value');
    }

    clearTimeout(_searchDebounceTimer);
    _searchDebounceTimer = setTimeout(function () {
      performSearchDrawerPredictive(query);
    }, 250);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.querySelector('.search-sidebar');
  if (drawer && typeof window.initProductCardSplides === 'function') {
    window.initProductCardSplides(drawer);
  }
});
